import {Component, EventEmitter, Output} from '@angular/core';
import {CloseableWindow} from "../../pro-report/shared/closeable-window";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PasswordMatchValidatorUtils} from "../../utils/password-match-validator-utils";
import {ChangePasswordService} from "../../service/change-password.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['../../../styles.scss', './change-password.component.scss']
})
export class ChangePasswordComponent implements CloseableWindow {

  constructor(private changePasswordService: ChangePasswordService,
              private fb: FormBuilder,
              private passwordValidator: PasswordMatchValidatorUtils) {
    this.passwordForm = this.fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    }, {validators: passwordValidator.passwordMatchValidator});
  }

  success = false;
  wrongOldPassword: boolean = false;
  passwordForm: FormGroup;

  @Output()
  closePanel = new EventEmitter<boolean>();

  close() {
    this.closePanel.emit(false);
  }

  changePassword() {
    this.changePasswordService.changePassword(this.passwordForm.get('oldPassword').value, this.passwordForm.get('newPassword').value).subscribe({
      next: resp => {
        if (resp) {
          this.success = true;
          this.wrongOldPassword = false;
        } else {
          this.wrongOldPassword = true;
        }
      }, error: error => {
        this.success = false
      }
    })
  }
}
